var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComfortableLN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "29px",
    viewBox: "0 0 33 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comfortable_l_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings_word",
    transform: "translate(-899.000000, -524.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.5,524 L930.5,524 C931.328427,524 932,524.671573 932,525.5 C932,526.328427 931.328427,527 930.5,527 L900.5,527 C899.671573,527 899,526.328427 899,525.5 C899,524.671573 899.671573,524 900.5,524 Z M900.5,537 L923.24,537 C924.068427,537 924.74,537.671573 924.74,538.5 C924.74,539.328427 924.068427,540 923.24,540 L900.5,540 C899.671573,540 899,539.328427 899,538.5 C899,537.671573 899.671573,537 900.5,537 Z M900.5,550 L927.2,550 C928.028427,550 928.7,550.671573 928.7,551.5 C928.7,552.328427 928.028427,553 927.2,553 L900.5,553 C899.671573,553 899,552.328427 899,551.5 C899,550.671573 899.671573,550 900.5,550 Z",
    id: "comfortable_l_n"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfortableLN);
export default __webpack_public_path__ + "static/media/comfortable_l_n.53a3a4a2e5ed15dc40f99c9389948bf9.svg";
export { ForwardRef as ReactComponent };